export default "__VITE_ASSET__CYI1yYpV__"